export enum SearchInputSymbolsCount {
  WithTicker = 1,
  Default = 2,
}
